const dateFormat = 'DD.MM.YYYY';
const DateRangePickerInput = {
    initialize: function () {
        const dateRangePickerInput = $('.daterangepickerinput');
        dateRangePickerInput
            .not('.initialized')
            .daterangepicker({
                singleDatePicker: true,
                locale: {
                    format: dateFormat,
                    cancelLabel: 'Clear',
                },
                autoApply: true,
                showDropdowns: true
            })
            .addClass('initialized');
    },

    moveDateEarlier: function (button) {
        let container = $(button).closest('.row');
        let dateRangePickerInputFrom = container.find('.daterangepickerinputfrom');
        let dateRangePickerInputTo = container.find('.daterangepickerinputto');

        let dateRangeValues = new DateRangeValues(dateRangePickerInputFrom.val(), dateRangePickerInputTo.val())
        if (dateRangeValues.difference === null) {
            return;
        }
        this.moveDateRange(dateRangeValues, -1)
        this.setDatePickerValues(dateRangePickerInputFrom, dateRangePickerInputTo, dateRangeValues)
    },

    moveDateLater: function (button) {
        let container = $(button).closest('.row');
        let dateRangePickerInputFrom = container.find('.daterangepickerinputfrom');
        let dateRangePickerInputTo = container.find('.daterangepickerinputto');
        let dateRangeValues = new DateRangeValues(dateRangePickerInputFrom.val(), dateRangePickerInputTo.val())
        if (dateRangeValues.difference === null) {
            return;
        }
        this.moveDateRange(dateRangeValues, 1)
        this.setDatePickerValues(dateRangePickerInputFrom, dateRangePickerInputTo, dateRangeValues)
    },

    moveDateRange: function (dateRangeValues, direction) {
        if (this.isWholeMonth(dateRangeValues)) {
            this.moveDateRangeByMonth(dateRangeValues, direction)
        } else {
            this.moveDateRangeByDays(dateRangeValues, direction)
        }
    },

    isWholeMonth: function (dateRangeValues) {
        return dateRangeValues.startDate.date() === 1
            && dateRangeValues.difference === dateRangeValues.startDate.daysInMonth();
    },

    moveDateRangeByMonth: function (dateRangeValues, direction) {
        dateRangeValues.startDate.month(dateRangeValues.startDate.month() + 1 * direction);
        dateRangeValues.endDate.month(dateRangeValues.endDate.month() + 1 * direction);
        dateRangeValues.endDate.date(dateRangeValues.startDate.daysInMonth());
    },

    moveDateRangeByDays: function (dateRangeValues, direction) {
        dateRangeValues.startDate.add(dateRangeValues.difference * direction, 'days');
        dateRangeValues.endDate.add(dateRangeValues.difference * direction, 'days');
    },

    setDatePickerValues: function (datePickerInputFrom, datePickerInputTo, dateRangeValues) {
        datePickerInputFrom.val(dateRangeValues.startDate.format(dateFormat));
        datePickerInputTo.val(dateRangeValues.endDate.format(dateFormat));
    }
}

window.dateRangePickerInput = DateRangePickerInput;


class DateRangeValues {
    constructor(dateRangeInputFromValue, dateRangeInputToValue) {
        this.startDate = this.parseDate(dateRangeInputFromValue);
        this.endDate = this.parseDate(dateRangeInputToValue);
        if (this.endDate !== null && this.startDate !== null) {
            this.difference = this.endDate.diff(this.startDate, 'days') + 1;
        } else {
            this.difference = null;
        }
    }

    parseDate(date) {
        date = window.moment(date.trim(), dateFormat);
        return date.isValid() ? date : null;
    }
}
